import styled, { keyframes } from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const WaitingPopupWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: ${fadeIn} 0.3s ease-in-out;
`;

export const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

export const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background-color: transparent;
  min-width: 200px;
  max-width: 80vw;
  z-index: 1;
`;

export const MessageContainer = styled.div`
  margin-top: 16px;
  text-align: center;
  color: white;
  font-size: 14px;
  font-weight: 500;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 4px;
  margin-top: 16px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${(props) => props.progress}%;
  background-color: ${COLOR_SYSTEM.get("Blue")?.[400]};
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
`;
